export const modalRouterOutlet = 'externalInfluencerConfigureModal';
